import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { DashboardYearFilter } from '../components/DashboardYearFilter';
import { useGPAData } from '../contexts';

const termTypes = [
    [1, 'Semester'], [2, 'Trimester'], [3, 'Quarter'], [4, 'Term'], [5, 'Summer'], [6, 'Annual']
] as const;

export const GPAFilterControls = () => {
    const { filter, updateFilter, activeSchoolYear } = useGPAData();
    const termTypeId = filter.termTypeId || 0;
    return <DashboardYearFilter idPrefix="gpa" years={filter.schoolYears} activeSchoolYear={activeSchoolYear}
        onApply={schoolYears => updateFilter({ schoolYears })}>
        <FormControl size="small" sx={{ minWidth: 150 }}>
            <InputLabel>Term Type</InputLabel>
            <Select value={termTypeId} label="Term Type" onChange={event => {
                const value = Number(event.target.value);
                updateFilter(value ? { termTypeId: value, termNumber: filter.termNumber || 1 } : { termTypeId: undefined, termNumber: undefined });
            }}>
                <MenuItem value={0}>Whole Year</MenuItem>
                {termTypes.map(([id, name]) => <MenuItem key={id} value={id}>{name}</MenuItem>)}
            </Select>
        </FormControl>
        {termTypeId > 0 && <FormControl size="small" sx={{ minWidth: 110 }}>
            <InputLabel>Term</InputLabel>
            <Select value={filter.termNumber || 1} label="Term" onChange={event => updateFilter({ termNumber: Number(event.target.value) })}>
                {[1, 2, 3, 4].map(number => <MenuItem key={number} value={number}>{number}</MenuItem>)}
            </Select>
        </FormControl>}
    </DashboardYearFilter>;
};
